document.addEventListener('DOMContentLoaded', function () {
  const menuToggle = document.querySelector('[data-menu-toggle]')
  const mobileMenu = document.querySelector('[data-mobile-menu]')
  const mobileMenuCloseButtons = document.querySelectorAll('[data-mobile-menu-close]')
  const menuOverlay = document.querySelector('[data-mobile-menu-overlay]')

  if (menuToggle && mobileMenu && menuOverlay) {
    menuToggle.addEventListener('click', function () {
      mobileMenu.classList.remove('-right-full')
      mobileMenu.classList.add('right-0')
      menuOverlay.classList.remove('hidden')
      document.body.style.overflow = 'hidden'
    })

    const closeMenu = function () {
      mobileMenu.classList.remove('right-0')
      mobileMenu.classList.add('-right-full')
      menuOverlay.classList.add('hidden')
      document.body.style.overflow = ''

      // Close all submenus
      const allSubmenus = document.querySelectorAll('[data-submenu-panel]')
      allSubmenus.forEach(function (submenu) {
        submenu.classList.remove('right-0')
        submenu.classList.add('-right-full')
      })
    }

    mobileMenuCloseButtons.forEach(function (closeButton) {
      closeButton.addEventListener('click', closeMenu)
    })

    menuOverlay.addEventListener('click', closeMenu)
  }

  // Submenu functionality
  const submenuTriggers = document.querySelectorAll('[data-submenu-trigger]')
  const submenuBackButtons = document.querySelectorAll('[data-submenu-back]')

  submenuTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault()
      const submenuKey = trigger.getAttribute('data-submenu-trigger')
      const submenuPanel = document.querySelector('[data-submenu-panel="' + submenuKey + '"]')

      if (submenuPanel) {
        submenuPanel.classList.remove('-right-full')
        submenuPanel.classList.add('right-0')
      }
    })
  })

  submenuBackButtons.forEach(function (backButton) {
    backButton.addEventListener('click', function () {
      const submenuPanel = backButton.closest('[data-submenu-panel]')
      if (submenuPanel) {
        submenuPanel.classList.remove('right-0')
        submenuPanel.classList.add('-right-full')

        // If there's a parent submenu (third-level), get the parent key
        const parentKey = backButton.getAttribute('data-submenu-parent')
        if (parentKey) {
          // This is a third-level submenu, so we need to show the parent submenu
          const parentPanel = document.querySelector('[data-submenu-panel="' + parentKey + '"]')
          if (parentPanel) {
            parentPanel.classList.remove('-right-full')
            parentPanel.classList.add('right-0')
          }
        }
      }
    })
  })

  // Language Selector Toggle
  const languageToggles = document.querySelectorAll('[data-language-toggle]')

  languageToggles.forEach(function (languageToggle) {
    const languageMenu = languageToggle.parentElement.querySelector('[data-language-menu]')

    if (languageToggle && languageMenu) {
      languageToggle.addEventListener('click', function (e) {
        e.stopPropagation()
        languageMenu.classList.toggle('hidden')
      })

      document.addEventListener('click', function () {
        languageMenu.classList.add('hidden')
      })
    }
  })

  // Header scroll behavior
  const header = document.querySelector('[data-header]')
  if (header) {
    let lastScroll = 0

    window.addEventListener('scroll', function () {
      const currentScroll = window.pageYOffset

      if (currentScroll > 50) {
        header.classList.add('scrolled')
      } else {
        header.classList.remove('scrolled')
      }

      lastScroll = currentScroll
    })
  }

  // Desktop Megamenu functionality
  const desktopSubmenuTriggers = document.querySelectorAll('[data-desktop-submenu-trigger]')
  const desktopMegamenus = document.querySelectorAll('[data-desktop-megamenu]')
  const desktopMegamenuOverlay = document.querySelector('[data-desktop-megamenu-overlay]')
  const desktopHeaderArea = document.querySelector('[data-header]')
  let activeMegamenu = null
  let activeTrigger = null
  let closeTimer = null

  function swapMegamenuInstantly(nextMegamenu) {
    if (!activeMegamenu || activeMegamenu === nextMegamenu) {
      return
    }

    const previousTransition = activeMegamenu.style.transition
    const nextTransition = nextMegamenu.style.transition

    activeMegamenu.style.transition = 'none'
    nextMegamenu.style.transition = 'none'

    activeMegamenu.style.height = '0'
    nextMegamenu.style.height = nextMegamenu.scrollHeight + 'px'

    activeMegamenu.offsetHeight

    activeMegamenu.style.transition = previousTransition
    nextMegamenu.style.transition = nextTransition
  }

  function closeAllMegamenus() {
    desktopMegamenus.forEach(function (megamenu) {
      megamenu.style.height = '0'
    })
    if (desktopMegamenuOverlay) {
      desktopMegamenuOverlay.classList.add('hidden')
    }
    // Remove active class from all triggers
    desktopSubmenuTriggers.forEach(function (t) {
      t.classList.remove('font-medium')
    })
    activeMegamenu = null
    activeTrigger = null
    if (closeTimer) {
      clearTimeout(closeTimer)
      closeTimer = null
    }
  }

  function isPointerInDesktopSafeZone(event) {
    if (!activeMegamenu || !desktopHeaderArea || !event) {
      return false
    }

    const headerRect = desktopHeaderArea.getBoundingClientRect()
    const megamenuRect = activeMegamenu.getBoundingClientRect()

    const safeLeft = Math.min(headerRect.left, megamenuRect.left)
    const safeRight = Math.max(headerRect.right, megamenuRect.right)
    const safeTop = Math.min(headerRect.top, megamenuRect.top)
    const safeBottom = Math.max(headerRect.bottom, megamenuRect.bottom)

    return (
      event.clientX >= safeLeft && event.clientX <= safeRight && event.clientY >= safeTop && event.clientY <= safeBottom
    )
  }

  function shouldCloseMegamenuImmediately(event) {
    if (!activeMegamenu || !desktopHeaderArea || !activeTrigger || !event) {
      return false
    }

    const headerRect = desktopHeaderArea.getBoundingClientRect()
    const megamenuRect = activeMegamenu.getBoundingClientRect()
    const triggerRect = activeTrigger.getBoundingClientRect()

    const isInHeaderBounds =
      event.clientX >= headerRect.left &&
      event.clientX <= headerRect.right &&
      event.clientY >= headerRect.top &&
      event.clientY <= headerRect.bottom

    const isInTopHeaderRow = isInHeaderBounds && event.clientY < triggerRect.top - 2
    const isBelowMegamenu = event.clientY > megamenuRect.bottom

    return isInTopHeaderRow || isBelowMegamenu
  }

  function scheduleCloseIfOutsideSafeZone(event) {
    if (!activeMegamenu) {
      return
    }

    if (closeTimer) {
      clearTimeout(closeTimer)
      closeTimer = null
    }

    closeTimer = setTimeout(function () {
      if (!isPointerInDesktopSafeZone(event)) {
        closeAllMegamenus()
      }
    }, 140)
  }

  function openMegamenu(trigger) {
    if (closeTimer) {
      clearTimeout(closeTimer)
      closeTimer = null
    }

    const megamenuKey = trigger.getAttribute('data-desktop-submenu-trigger')
    const megamenu = document.querySelector('[data-desktop-megamenu="' + megamenuKey + '"]')

    if (megamenu && activeMegamenu !== megamenu) {
      const hasOpenMegamenu = activeMegamenu !== null

      // Close all other megamenus
      desktopMegamenus.forEach(function (m) {
        if (m !== megamenu) {
          m.style.height = '0'
        }
      })

      // Remove active class from all triggers
      desktopSubmenuTriggers.forEach(function (t) {
        t.classList.remove('font-medium')
      })

      // Add active class to current trigger
      trigger.classList.add('font-medium')

      // First open keeps original slide animation, switching between open menus is instant
      if (hasOpenMegamenu) {
        swapMegamenuInstantly(megamenu)
      } else {
        megamenu.style.height = megamenu.scrollHeight + 'px'
      }

      if (desktopMegamenuOverlay) {
        desktopMegamenuOverlay.classList.remove('hidden')
      }
      activeMegamenu = megamenu
      activeTrigger = trigger
    }
  }

  // Hover events for triggers
  desktopSubmenuTriggers.forEach(function (trigger) {
    trigger.addEventListener('mouseenter', function (e) {
      e.preventDefault()
      openMegamenu(trigger)
    })
  })

  // Close megamenu when hovering a top-level nav link that has no submenu
  const desktopMainNav = document.querySelector('[data-header] nav')
  if (desktopMainNav) {
    desktopMainNav.querySelectorAll('a').forEach(function (link) {
      if (!link.hasAttribute('data-desktop-submenu-trigger')) {
        link.addEventListener('mouseenter', function () {
          closeAllMegamenus()
        })
      }
    })
  }

  // Keep megamenu open when hovering over it
  desktopMegamenus.forEach(function (megamenu) {
    megamenu.addEventListener('mouseenter', function () {
      if (closeTimer) {
        clearTimeout(closeTimer)
        closeTimer = null
      }
    })
  })

  document.addEventListener('mousemove', function (event) {
    if (!activeMegamenu) {
      return
    }

    if (shouldCloseMegamenuImmediately(event)) {
      closeAllMegamenus()
      return
    }

    if (isPointerInDesktopSafeZone(event)) {
      if (closeTimer) {
        clearTimeout(closeTimer)
        closeTimer = null
      }
      return
    }

    scheduleCloseIfOutsideSafeZone(event)
  })

  // Close on overlay click
  if (desktopMegamenuOverlay) {
    desktopMegamenuOverlay.addEventListener('click', function () {
      closeAllMegamenus()
    })
  }

  // Close on escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && activeMegamenu) {
      closeAllMegamenus()
    }
  })

  // Close when clicking outside megamenu area
  document.addEventListener('click', function (e) {
    if (activeMegamenu && !activeMegamenu.contains(e.target) && activeTrigger && !activeTrigger.contains(e.target)) {
      closeAllMegamenus()
    }
  })
})
